"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapAndValidateBaseUrls = mapAndValidateBaseUrls;
const internalDomains = ['.ori.local', '.services.ori'];
function mapAndValidateBaseUrls(allServiceUrls, requiredServices) {
  const uniqueRequiredServices = [...new Set(requiredServices)];
  const missingRequiredServices = uniqueRequiredServices.filter(requiredServiceName => !allServiceUrls[requiredServiceName]?.baseUrl);
  if (missingRequiredServices.length > 0) {
    throw new Error(`Required services '${missingRequiredServices.join("', '")}' or their Base URL not found in passed data`);
  }
  const baseUrls = Object.entries(allServiceUrls).reduce((accumulator, [serviceName, {
    baseUrl
  }]) => {
    if (!baseUrl) {
      return accumulator;
    }
    if (internalDomains.some(domain => baseUrl.includes(domain))) {
      return accumulator;
    }
    accumulator[`${serviceName}Url`] = baseUrl;
    return accumulator;
  }, {});
  return baseUrls;
}
